import { Link } from 'react-router-dom';

export default function AboutPage() {
    return (
        <div className="min-h-screen" data-testid="about-page">
            {/* Header */}
            <header className="text-center py-12 md:py-16">
                <h1 className="text-4xl md:text-5xl italic mb-8">
                    O projektu
                </h1>
                <div className="w-full max-w-3xl mx-auto h-px bg-foreground/30" />
            </header>

            {/* Content */}
            <section className="max-w-2xl mx-auto px-6 pb-24">
                <div className="text-lg leading-relaxed">
                    <p className="mb-6">
                        Listovna vznikla z lásky k českému psaní a touhy vytvořit prostor, 
                        kde se mohou setkávat autoři a čtenáři krátkých příběhů.
                    </p>

                    <h2 className="text-2xl italic mt-12 mb-6">
                        Naše poslání
                    </h2>
                    <p className="mb-6">
                        Věříme, že povídka je umělecká forma, která si zaslouží více pozornosti. 
                        V době, kdy je náš čas roztříštěný a pozornost vzácná, nabízí povídka 
                        možnost ponořit se do příběhu, prožít silné emoce a zase se vrátit 
                        do reality – to vše během jednoho večera nebo cesty metrem.
                    </p>

                    <h2 className="text-2xl italic mt-12 mb-6">
                        Pro koho je Listovna
                    </h2>
                    <p className="mb-6">
                        Listovna je pro všechny, kdo milují české slovo a dobře vyprávěný příběh. 
                        Ať už jste zaneprázdnění profesionálové hledající chvilku relaxace, 
                        nebo vášniví čtenáři toužící po nových literárních zážitcích – 
                        u nás najdete povídky, které vás osloví.
                    </p>

                    <h2 className="text-2xl italic mt-12 mb-6">
                        Jak to funguje
                    </h2>
                    <ul className="space-y-3 mb-6">
                        <li className="flex gap-3">
                            <span className="italic">1.</span>
                            <span>Zaregistrujte se a získejte první měsíc zdarma</span>
                        </li>
                        <li className="flex gap-3">
                            <span className="italic">2.</span>
                            <span>Prohlížejte si náhledy povídek a vyberte si, co vás zajímá</span>
                        </li>
                        <li className="flex gap-3">
                            <span className="italic">3.</span>
                            <span>Čtěte bez omezení – online i offline</span>
                        </li>
                        <li className="flex gap-3">
                            <span className="italic">4.</span>
                            <span>Ukládejte si oblíbené povídky a sledujte svůj pokrok</span>
                        </li>
                    </ul>

                    <h2 className="text-2xl italic mt-12 mb-6">
                        Předplatné
                    </h2>
                    <p className="mb-6">
                        Předplatné Listovny stojí 149 Kč měsíčně. Noví uživatelé získávají 
                        první měsíc zdarma. Můžete kdykoli zrušit.
                    </p>

                    <div className="mt-16 py-8 border-t border-b border-foreground/20 text-center">
                        <p className="italic text-xl">
                            "Dobrá povídka je jako espresso – krátká, intenzivní a nezapomenutelná."
                        </p>
                        <p className="text-sm text-muted-foreground mt-4">
                            — Tým Listovny
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}
